import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const DoubleArrow = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="double-arrow"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 13L4.5359 9.25L11.4641 9.25L8 13Z" fill={getColor(color, isColorInherited)} />
    <path d="M8 3L11.4641 6.75L4.5359 6.75L8 3Z" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
